import { Box, Message, Text } from '@workwhile/ui'
import { useAuthContext } from 'components/auth'

export const AutoBackfillIndicator = () => {
  const { company: companyInfo } = useAuthContext()
  const autoBackfill = companyInfo?.backfillPolicy

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Message
        variant={autoBackfill ? 'info' : 'warning'}
        systemLevel={true}
        borderRadius="10px"
      >
        <Box display="flex" flexDirection="column">
          {autoBackfill ? (
            <>
              <Text style={{ fontWeight: 'bold' }}>
                We'll automatically backfill any open spots on this assignment
              </Text>
              <Text fontSize={1}>
                This includes workers who quit or are removed, but not workers
                who call out. To change this, please contact your Account
                Manager.
              </Text>
            </>
          ) : (
            <>
              <span style={{ fontWeight: 'bold' }}>
                Once the assignment starts, open spots will not be backfilled
                unless you explicitly request additional workers.
              </span>
              <span>To change this, please contact your Account Manager.</span>
            </>
          )}
        </Box>
      </Message>
    </Box>
  )
}
